angular.module('v3sWbtPlayerApp').factory('v3sModal', ["$modal", "$rootScope", function ($modal, $rootScope) {
    var modal;

    function show(options) {
        if (!!modal) return;
        var scope = $rootScope.$new();
        var backdrop = true;
        var container = '#wbtContent';
        var customClass = options.customClass || null;

        if (!!options.onPage) {
            backdrop = false;
            container = 'v3s-document';
        }

        scope.title = options.title;
        scope.iconButtons = options.iconButtons || false;
        scope.message = options.message;
        scope.content = options.content;
        scope.actions = options.actions;
        scope.vars = options.vars;

        scope.touched = false;
        scope.startAction = function (name, action, form) {
            scope.touched = true;
            if (name.indexOf("cancel") == -1) {
                if (form.$valid) {
                    action();
                }
            } else {
                action();
            }
        };

        modal = $modal({ scope: scope, locals: options, templateUrl: 'app/js/helper/modal/modal.tpl.html', show: true, backdrop: backdrop, container: container });

        modal.$promise.then(function (val) {
            if (!!customClass) {
                val.element.addClass(customClass);
            }
            if (!options.actions) {
                val.element.addClass("no-actions");
            }
            if (!options.vars) {
                val.element.addClass("no-vars");
            }

            if (!!options.onHide) {
                modal.$scope.$on('modal.hide', function () {
                    options.onHide();
                });
            }
            modal.$scope.$on('modal.hide', function () {
                modal = null;
            });

        });

        return modal;
    }

    function hide(modal) {
        if (!!modal) {
            modal.$promise.then(modal.hide);
            modal = null;
        }
    }

    return {
        show: show,
        hide: hide
    }

}]);